import { createContext  } from "react";
import { ProductDialog } from "../Models/Product";
 
export const ProductDialogContext = createContext<ProductDialog>({open: false, toggleDialog: ()=>null})
